import { Codebook } from '../Codebook'

export enum AlfredThemeId {
  PURPLE = 1,
  RED = 2,
  ORANGE = 3,
  YELLOW = 4,
  GREEN = 5,
  MINT = 6,
  SKY = 7,
  BLUE = 8,
  PINK = 9,
  DARK = 10,
}

export class AlfredTheme extends Codebook<AlfredThemeId> {
  private constructor(
    id: AlfredThemeId,
    public readonly hexCode: string,
  ) {
    super(id)
  }

  static readonly PURPLE = new AlfredTheme(AlfredThemeId.PURPLE, '#6F2F6A')
  static readonly RED = new AlfredTheme(AlfredThemeId.RED, '#CF3340')
  static readonly ORANGE = new AlfredTheme(AlfredThemeId.ORANGE, '#E66735')
  static readonly YELLOW = new AlfredTheme(AlfredThemeId.YELLOW, '#F4A833')
  static readonly GREEN = new AlfredTheme(AlfredThemeId.GREEN, '#76B03F')
  static readonly MINT = new AlfredTheme(AlfredThemeId.MINT, '#2BAB85')
  static readonly SKY = new AlfredTheme(AlfredThemeId.SKY, '#2D9CCF')
  static readonly BLUE = new AlfredTheme(AlfredThemeId.BLUE, '#3973D1')
  static readonly PINK = new AlfredTheme(AlfredThemeId.PINK, '#CB5A99')
  static readonly DARK = new AlfredTheme(AlfredThemeId.DARK, '#505762')
}
